import React from 'react';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { CustomButton, CustomInput, Spinner } from 'components';
import { ROUTES } from 'constants/routes';

import './ProfileForm.scss';
import { updateUserValidationScheme } from '../../validation';
import { usersService } from '../../services';

export const ProfileForm = () => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { password: '' },
    onSubmit: async (values) => {
      await usersService.updateUser(values);
      navigate(ROUTES.pdf_history);
    },
    validationSchema: updateUserValidationScheme,
  });

  return (
    <form onSubmit={formik.handleSubmit} className="login-form-container">
      <div className="login-form-input-box">
        <CustomInput
          id="password"
          name="password"
          type="password"
          label="New password"
          placeholder="Choose your password"
          width="100%"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.password && formik.errors.password && (
          <div className="login-form-validation-error">
            {formik.errors.password}
          </div>
        )}
      </div>

      <CustomButton type="submit" text="Submit" width="100%" />
    </form>
  );
};
